import React from 'react';
import { Tabs, Tab, Box, styled, Typography, theme } from '@hiver/hiver-ui-kit';

import { yelloyTabStyles } from './style';

const StyledTabs = styled(Tabs)(yelloyTabStyles.bar);

const StyledTab = styled(Tab)(yelloyTabStyles.button);

export default function YellowTabs({ onTabchange, selected, tabsList }) {
  const handleChange = (_event, newValue) => {
    onTabchange(newValue);
  };

  return (
    <Box sx={{ bgcolor: '#fff' }}>
      <StyledTabs
        value={selected}
        onChange={handleChange}
        TabIndicatorProps={{ children: <span className='MuiTabs-indicatorSpan' /> }}
      >
        {tabsList.map((tab) => (
          <StyledTab 
            value={tab.key} 
            key={tab.key} 
            disableRipple
            label={
              <Typography variant="h2" color={theme.palette.gray.black}>
                Back
              </Typography>
            }  
          />
        ))}
      </StyledTabs>
    </Box>
  );
}
